/** Static preview data until GET /api/v1/rewards/dashboard is live */

export const REWARDS_MOCK_VIP = {
  tierKey: "silver",
  tierName: "SILVER CLOVER",
  currentPts: 2840,
  nextTierPts: 25000,
  nextTierName: "Gold Clover",
  progressPct: 11.36,
  ptsLabel: "2,840 / 25,000 pts",
  toNextLabel: "22,160 pts",
};

export const REWARDS_MOCK_BALANCES = {
  cloverCoins: { amount: "4,250", weekDelta: "+480" },
  freeSpins: { amount: "150", meta: "3 packs · earliest exp 2d" },
  bonuses: [
    { name: "Welcome 200%", amount: "$140", wagerPct: 70 },
    { name: "Cashback Mon", amount: "$48", wagerPct: 66 },
  ],
};

export const REWARDS_MOCK_STREAK = {
  days: 4,
  dayPills: [
    { label: "M", status: "done" },
    { label: "T", status: "done" },
    { label: "W", status: "done" },
    { label: "T", status: "done" },
    { label: "F", status: "today" },
    { label: "S", status: "pending" },
    { label: "🏆", status: "mega" },
  ],
  todayReward: "20 FS",
};

export const REWARDS_MOCK_ACTIVITY = [
  { icon: "🍀", title: "Mission Hub · 500× Hit", time: "Today 14:22", amount: "+1,000 CC" },
  { icon: "🌀", title: "Weekly Race · Top 50", time: "Today 11:08", amount: "+50 FS" },
  { icon: "🍀", title: "Gameplay wagers", time: "Yesterday", amount: "+387 CC" },
  { icon: "🏆", title: "Trophy · 500× Hit unlocked", time: "Yesterday", amount: "+250 CC" },
  { icon: "🌀", title: "Bonus Buy Hunter claim", time: "2 days ago", amount: "+100 FS" },
];

export const REWARDS_MOCK_BADGES = [
  { tier: "gold", icon: "🏆", name: "First Win", date: "Mar 12", locked: false, condition: "Land your first ever winning spin or bet — the journey begins." },
  { tier: "silver", icon: "⚡", name: "Speed Demon", date: "Mar 18", locked: false, condition: "Place 50 bets within a single 10-minute session." },
  { tier: "bronze", icon: "🎯", name: "Sharp Shooter", date: "Mar 22", locked: false, condition: "Cash out three Crash rounds in a row at 5× or higher." },
  { tier: "gold", icon: "💰", name: "Big Spender", date: "Apr 04", locked: false, condition: "Wager a total of $1,000 within a single calendar day." },
  { tier: "diamond", icon: "💎", name: "Mega Win", date: "Apr 19", locked: false, condition: "Hit a single-spin win of $500 or more on any game." },
  { tier: "gold", icon: "🍀", name: "Lucky Streak", date: "Apr 27", locked: false, condition: "Score 10 winning spins in a row on any slot." },
  { tier: "silver", icon: "🚀", name: "Crash King", date: "May 08", locked: false, condition: "Cash out at 50× or higher on a Crash game three times in one week." },
  { tier: "gold", icon: "🔥", name: "Hot Streak", date: "May 14", locked: false, condition: "Maintain a 5-day play streak without skipping a single day." },
  { tier: "bronze", icon: "🎲", name: "Dice Master", date: "May 22", locked: false, condition: "Win 25 dice game rounds in a single 30-day window.", extra: true },
  { tier: "silver", icon: "🃏", name: "Card Shark", date: "May 02", locked: false, condition: "Win 100 hands of any card game (Blackjack, Poker, Baccarat).", extra: true },
  { tier: "gold", icon: "🎰", name: "Reel Roller", date: "Apr 10", locked: false, condition: "Spin 5,000 slot rounds across any games combined.", extra: true },
  { tier: "bronze", icon: "⚡", name: "Daily Visitor", date: "Apr 03", locked: false, condition: "Log in and play at least one round on 14 different days.", extra: true },
  { tier: "gold", icon: "🎁", name: "Bonus Buy King", date: "May 19", locked: false, condition: "Trigger 20 bonus rounds via the Bonus Buy feature.", extra: true },
  { tier: "silver", icon: "🌙", name: "Night Owl", date: "May 11", locked: false, condition: "Play 10 sessions between 02:00 and 06:00 local time.", extra: true },
  { tier: "diamond", icon: "🐲", name: "Dragon Slayer", date: "May 16", locked: false, condition: "Beat the dragon bonus round on Dragon's Den slot 10 times.", extra: true },
  { tier: "gold", icon: "🎯", name: "100× Hunter", date: "May 20", locked: false, condition: "Land a 100× single-spin multiplier on any slot.", extra: true },
  { tier: "bronze", icon: "🔄", name: "Comeback Kid", date: "May 24", locked: false, condition: "Recover from a $500 deficit and end the session in profit.", extra: true },
  { tier: "silver", icon: "⭐", name: "Rising Star", date: "May 26", locked: false, condition: "Climb three VIP tiers within a single calendar month.", extra: true },
  { tier: "gold", icon: "🏅", name: "Tournament Top 10", date: "May 28", locked: false, condition: "Finish in the top 10 of any Golden Clover tournament.", extra: true },
  { tier: "locked", icon: "🏆", name: "Diamond Tier", date: "Locked", locked: true, condition: "Reach Diamond VIP — the rarest tier on the clover ladder.", extra: true },
  { tier: "locked", icon: "🐳", name: "Whale Status", date: "Locked", locked: true, condition: "Wager a lifetime total of $100,000 on Golden Clover.", extra: true },
  { tier: "locked", icon: "⚔️", name: "Race Winner", date: "Locked", locked: true, condition: "Finish #1 in the Weekly Race leaderboard.", extra: true },
  { tier: "locked", icon: "👑", name: "King of Slots", date: "Locked", locked: true, condition: "Play 10,000 slot rounds across the entire game catalog.", extra: true },
  { tier: "locked", icon: "🌟", name: "Legend", date: "Locked", locked: true, condition: "Earn all 32 achievement medals on the wall.", extra: true },
  { tier: "locked", icon: "🦅", name: "Apex Predator", date: "Locked", locked: true, condition: "Hold the #1 race spot for three consecutive weeks.", extra: true },
  { tier: "locked", icon: "💯", name: "Perfect Streak", date: "Locked", locked: true, condition: "Maintain a 30-day play streak without missing a single day.", extra: true },
  { tier: "locked", icon: "🎖️", name: "Veteran", date: "Locked", locked: true, condition: "Stay active on Golden Clover for 365 consecutive days.", extra: true },
  { tier: "locked", icon: "🪙", name: "Big Spender", date: "Locked", locked: true, condition: "Place a single bet of $5,000 or more on any game.", extra: true },
  { tier: "locked", icon: "🃏", name: "Card Counter", date: "Locked", locked: true, condition: "Win 50 Blackjack hands with a hand value of exactly 21.", extra: true },
  { tier: "locked", icon: "🥇", name: "First Place", date: "Locked", locked: true, condition: "Win first place in any tournament for the first time.", extra: true },
  { tier: "locked", icon: "🛡️", name: "Loyal Player", date: "Locked", locked: true, condition: "Make at least one deposit every month for six months in a row.", extra: true },
  { tier: "locked", icon: "⚡", name: "Lightning Round", date: "Locked", locked: true, condition: "Win 5 rounds across any games in under 60 seconds total.", extra: true },
];

export function getRewardsMockState() {
  const earned = REWARDS_MOCK_BADGES.filter((b) => !b.locked).length;
  return {
    vip: REWARDS_MOCK_VIP,
    balances: REWARDS_MOCK_BALANCES,
    streak: REWARDS_MOCK_STREAK,
    badges: REWARDS_MOCK_BADGES,
    activity: REWARDS_MOCK_ACTIVITY,
    earnedCount: earned,
    totalBadges: REWARDS_MOCK_BADGES.length,
    isPreviewDemo: true,
    lastUpdateSec: 12,
  };
}
